export function ShDashboardsSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/sh-dashboards.svg'"></ng-include>`
    }
}